'use client';

import { ReactNode } from 'react';
import { ToastContainer } from 'react-toastify';

import { useMediaQueries } from '@repo/cc-ds';

import styles from './snackbar-provider.module.scss';

interface SnackbarProviderProps {
  children: ReactNode;
  containerId?: string;
  enableMultiContainer?: boolean;
  testCy?: string;
  testId?: string;
}

export const SnackbarProvider = ({
  children,
  containerId = undefined,
  enableMultiContainer = false,
  // eslint-disable-next-line arrow-body-style
}: SnackbarProviderProps) => {
  const mediaQuery = useMediaQueries();

  return (
    <>
      {children}
      <ToastContainer
        autoClose={false}
        closeOnClick
        draggable={false}
        hideProgressBar
        newestOnTop={false}
        pauseOnFocusLoss
        pauseOnHover
        position={mediaQuery.sm ? 'top-right' : 'bottom-center'}
        rtl={false}
        toastClassName={styles.toastClassName}
        {...(enableMultiContainer && containerId !== undefined ? { containerId, enableMultiContainer } : {})}
        {...(mediaQuery.sm ? {} : { limit: 3 })}
      />
    </>
  );
};
